// External imports
import { BookOpen } from "lucide-react";

/**
 * DocsHeader Component
 * Renders the documentation page header with a title, icon, and description
 * Features a bordered header and responsive text sizing
 */
export const DocsHeader = () => {
  return (
    <div className="border-b border-border">
      {/* Container for content centering and padding */}
      <div className="container mx-auto px-4 py-16">
        {/* Content wrapper with centered layout */}
        <div className="flex flex-col items-center text-center">
          <BookOpen className="mb-6 h-12 w-12 text-foreground" />
          <h1 className="mb-6 font-display text-2xl font-bold text-foreground md:text-4xl">
            Documentation
          </h1>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Learn how to get started with Tables and explore its
            features.
          </p>
        </div>
      </div>
    </div>
  );
};
